import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Hook para rastrear mudanças de página
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
    });
  }, [location]);

  // Função para enviar eventos customizados
  const trackEvent = (eventName, parameters = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...parameters,
    });
  };

  // Função para rastrear conversões
  const trackConversion = (conversionId, value = null, currency = 'BRL') => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'conversion',
      send_to: conversionId,
      value: value,
      currency: currency,
    });
  };

  return {
    trackEvent,
    trackConversion,
  };
};
